export const AUTH_FULL_PAGE_REDIRECT = 'auth_full_page_redirect';
export const EMPTY_CART_FEATURE_VARIANT = 'empty_cart_feature_variant';

export const DELAYED_ACCOUNT_CREATION_ON_CHECKOUT_PAGE =
    'delayed_account_creation_on_checkout_page';

export const CART_RECOMMENDATION_FEATURES = 'cart_recommendations_features';
